import React from "react";
import { useTranslation } from "react-i18next";
import { GET } from "../../utils/HttpClient";
import { defaultInterfaceTransactionDetail } from "../../constance/dataTypes";
import * as _ from "lodash";
import { formatComma } from "../../utils/stringFormat";
import { Button, Modal, Space, Input, Alert, Empty, Row, Col, Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR } from "../../constance/color";
import TSTable from "../common/TSTable";
import propTypes from "prop-types";
import { dateTimeToHumanString } from "../../utils/Utils";

export default function InterfaceAXTransactionModal(props) {
  const { open, onClose, onInterfaceAX, url, target } = props;

  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [detail, setDetail] = React.useState(defaultInterfaceTransactionDetail);
  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${url}${target}/ref-history/`);
      setDetail({ ...defaultInterfaceTransactionDetail, ...response.data });
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  };

  const renderEmpty = () => (
    <Empty
      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
      imageStyle={{ height: 60 }}
      description={
        <span>
          <Title level={4}>{t("interface_ax_history.empty")} </Title>
          {t("interface_ax_history.empty_description")}
        </span>
      }
    >
      <ColorButton
        type="primary"
        override={BLUE_COLOR}
        onClick={() => {
          onClose();
          onInterfaceAX(target);
        }}
      >
        {t("do_interface_ax")}
      </ColorButton>
    </Empty>
  );

  const renderRequestBody = () => {
    const requestBody = _.get(detail, "request_body", "");

    const dataSource = _.get(requestBody, "list", []).map((item, index) => ({
      key: index,
      itemId: _.get(item, "ItemId", "-"),
      wareHouse:
        _.get(item, "InventDim.inventLocationId", "-") ||
        _.get(item, "InventDimDC.inventLocationId", "-"),
      location:
        _.get(item, "InventDim.wMSLocationId", "-") ||
        _.get(item, "InventDimDC.wMSLocationId", "-"),
      batch:
        _.get(item, "InventDim.inventBatchId", "-") ||
        _.get(item, "InventDimDC.inventBatchId", "-"),
      qty: `${formatComma(
        Object.keys(item).find(
          (key) => key.includes("Qty") && !key.includes("Pcs")
        )
          ? _.get(
              item,
              Object.keys(item).find(
                (key) => key.includes("Qty") && !key.includes("Pcs")
              ),
              0
            )
          : 0
      )} ${_.get(item, "purchUnit", "")}`,
    }));

    const columns = [
      {
        title: "ItemId",
        dataIndex: "itemId",
        key: "itemId",
        render: (text) => <strong>{text}</strong>,
      },
      {
        title: "WareHouse",
        dataIndex: "wareHouse",
        key: "wareHouse",
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "location",
      },
      {
        title: "Batch",
        dataIndex: "batch",
        key: "batch",
      },
      {
        title: "QTY",
        dataIndex: "qty",
        key: "qty",
      },
    ];

    return (
      <div className="exportItemList-table">
        <Table dataSource={dataSource} columns={columns} pagination={false} />
      </div>
    );
  };

  const renderContent = () => {
    if (!isLoading && !detail.id) {
      return renderEmpty();
    }
    return (
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row>
          <Col span={6}>
            <Space direction="vertical">
              <label style={{ fontWeight: "bolder" }}>{t("date")}</label>
              {dateTimeToHumanString(detail.created)}
            </Space>
          </Col>
          <Col>
            <Space direction="vertical">
              <label style={{ fontWeight: "bolder" }}>{t("interface_ax_history.url")}</label>
              {detail.url}
            </Space>
          </Col>
        </Row>
        <div>
          <label style={{ fontWeight: "bolder" }}>{t("interface_ax_history.raw_data")}</label>
          <Input.TextArea
            value={JSON.stringify(detail.request_body, null, 4)}
            readOnly
            style={{ minHeight: "150px" }}
          />
        </div>
        {renderRequestBody()}
        <div>
          <label style={{ fontWeight: "bolder" }}>{t("interface_ax_history.result")}</label>
          <Input.TextArea
            value={detail.response_text}
            readOnly
            style={{ minHeight: "150px" }}
          />
        </div>
      </Space>
    );
  };

  React.useEffect(() => {
    if (open) {
      fetchData();
    }
  }, [open]);

  return (
    <Modal
      title={t("interface_ax_history.title")}
      centered={false}
      visible={open}
      onCancel={onClose}
      width={1200}
      footer={
        <Button
          variant="filled"
          color="default"
          icon={<CloseOutlined />}
          onClick={onClose}
        >
          {t("close")}
        </Button>
      }
    >
      {isLoading && <Alert message={t("loading")} type="info" showIcon />}
      {errorMessages && <Alert message={errorMessages} type="error" showIcon />}
      {renderContent()}
    </Modal>
  );
}

InterfaceAXTransactionModal.defaultProps = {
  open: false,
  onClose: () => null,
  onInterfaceAX: () => null,
  url: "",
  target: "",
};

InterfaceAXTransactionModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  onInterfaceAX: propTypes.func,
  url: propTypes.string.isRequired,
  target: propTypes.string.isRequired,
};
